import {defineComponent, h} from 'vue';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import {ROUTE_REGEX_BASE64_URL} from '../utils/portuna';

const LoginView          = () => import('@/views/LoginView.vue');
const HomeView           = () => import('@/views/home/HomeView.vue');
const WidgetDashboard    = () => import('@/views/home/WidgetDashboard.vue');
const HomeSettings       = () => import('@/views/home/HomeSettings.vue');
const RecoverPassword    = () => import('@/views/RecoverPassword.vue');
const ChangePassword     = () => import('@/views/ChangePassword.vue');
const Maintenance        = () => import('@/views/Maintenance.vue');
const DataprocessingView = () => import('@/views/DataprocessingView.vue');
const ChangelogView      = () => import('@/views/ChangelogView.vue');
const StaticFaq          = () => import('@/views/StaticFaq.vue');
const IntranetSearch     = () => import('@/views/IntranetSearch.vue');
const AppInviteView      = () => import('@/views/AppInviteView.vue');
const CreateAccount      = () => import('@/views/CreateAccount.vue');

export const redirectToPHPComponent = defineComponent({
    components: {
        LoadingIndicator,
    },
    render()
    {
        window.location.reload();
        return h(LoadingIndicator);
    },
});

let meta: MetaData = {module: 'application'};

let defaultRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta,
    },
    {
        path: '/point-to/:wildcard*',
        redirect: {name: 'home'},
        meta,
    },
    {
        path: '/signed-in/:wildcard*',
        redirect: {name: 'home'},
        meta,
    },
    {
        path: '/application/activity/index/id/:id',
        name: 'activity',
        props: true,
        component: HomeView,
        meta,
    },
    {
        path: '/application/startpage/edit',
        name: 'activity-settings',
        component: HomeSettings,
        meta,
    },
    {
        path: '/application/application/dashboard',
        name: 'widget-dashboard',
        component: WidgetDashboard,
        meta,
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            onlyLoggedOut: true,
            disableNotifications: true,
        },
    },
    {
        path: '/app-invite',
        name: 'app-invite',
        component: AppInviteView,
        meta: {
            layout: 'blank',
            allowLoggedOut: true,
            disableNotifications: true,
        },
    },
    {
        path: '/create-account/:hash',
        name: 'create-account',
        component: CreateAccount,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            onlyLoggedOut: true,
            disableNotifications: true,
        },
        props(route: RouteLocationStringParam)
        {
            return {
                hash: route.params.hash,
            };
        },
    },
    {
        path: '/login/referrer/:referrer?',
        name: 'login-referrer',
        component: LoginView,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            onlyLoggedOut: true,
            disableNotifications: true,
        },
    },
    {
        path: '/recover',
        name: 'recover-password',
        component: RecoverPassword,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            onlyLoggedOut: true,
            disableNotifications: true,
        },
    },
    {
        path: '/changepassword/:email(' + ROUTE_REGEX_BASE64_URL + ')/:token',
        name: 'change-password',
        component: ChangePassword,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            onlyLoggedOut: true,
            disableNotifications: true,
        },
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance,
        meta: {
            layout: 'minimal',
            allowLoggedOut: true,
            disableNotifications: true,
        },
        props: {
            message: 'Die Webseite wird aktuell gewartet.<br />Bitte versuchen Sie es sp&auml;ter erneut.',
        },
    },
    {
        path: '/dataprocessing',
        name: 'dataprocessing',
        component: DataprocessingView,
        meta,
    },
    {
        path: '/changelog',
        name: 'changelog',
        component: ChangelogView,
        meta,
    },
    {
        path: '/help',
        name: 'help',
        component: StaticFaq,
        meta,
    },
    {
        path: '/search/search/index/q/:input?',
        redirect: {name: 'search'},
        meta,
    },
    {
        path: '/search/:input?',
        name: 'search',
        component: IntranetSearch,
        props(route: RouteLocationStringParam)
        {
            return {
                input: route.params.input,
            };
        },
        meta,
    },
    {
        path: '/logout',
        name: 'logout',
        component: redirectToPHPComponent,
    },
];

if (process.env.NODE_ENV !== 'production')
{
    const DesignView     = () => import('../views/_Debug/DesignView.vue');
    const FormView       = () => import('../views/_Debug/FormView.vue');
    const ResponsiveView = () => import('../views/_Debug/ResponsiveView.vue');

    defaultRoutes.push(
        {
            name: 'debug-design',
            path: '/application/debug/design',
            component: DesignView,
            meta: {
                module: 'debug',
            },
        },
        {
            name: 'debug-form',
            path: '/application/debug/form',
            component: FormView,
            meta: {
                module: 'debug',
            },
        },
        {
            name: 'debug-responsive',
            path: '/application/debug/responsive/:tab?',
            component: ResponsiveView,
            meta: {
                module: 'debug',
            },
        },
    );
}

defaultRoutes.push(
    //default route if no match -> reload to get php view
    {
        path: '/:wildcard*',
        component: redirectToPHPComponent,
    },
);

export default defaultRoutes;
